const SubscriptionLicenseIcon = ({ size = 24, color = '#7098FF', ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M8 4.625H16C17.3117 4.625 18.375 5.68832 18.375 7V18C18.375 19.3117 17.3117 20.375 16 20.375H8C6.68832 20.375 5.625 19.3117 5.625 18V7C5.625 5.68832 6.68832 4.625 8 4.625Z"
                stroke={color}
                strokeWidth="1.25"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M9 8.5H15" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 11.5H15" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 14.5H13.5" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default SubscriptionLicenseIcon
